import React from "react";
import { Link } from "react-router-dom";

const Success = () => {
  return (
    <div className="min-h-[90vh] flex items-center justify-center ">
      <div className="p-2 w-[95vw] lg:w-[50vw] h-[70vh] rounded-lg shadow-lg bg-white flex justify-start items-center flex-col">
        <img className=" " src="./successsign.png" alt="" />
        <h1 className="text-2xl font-semibold mb-5">
          Thank you for Ordering !
        </h1>
        <p className="text-center text-slate-900 lg:px-20">
          We know you’re going to love it. You can track your order here, review
          us here, or shop again here.
        </p>

        <div className=" mt-5 flex flex-row flex-wrap">
          <Link
            to="/profile"
            className=" m-3 rounded border font-bold text-slate-800 px-3 py-1 flex items-center justify-center"
          >
            View Order
          </Link>
          <Link
            to="/products"
            className=" m-3 rounded bg-orange-400 text-white  border border-orange-400 font-bold  px-3 py-1 flex items-center justify-center"
          >
            Continue Shopping
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Success;
